import {useEffect} from "react";
import {iOS} from "../../consts/ios";

export const useGoToFullScreenOnAnyClick = (container, forceLandscape) => {
    useEffect(() => {
        const  q = container.current;
        if ( !q ) return;

        if ( ! forceLandscape ) {
            return;
        }
        if ( ! iOS ) return ;

        const doOnce = () => {
            if(q.requestFullscreen)
                q.requestFullscreen();
            else if(q.webkitRequestFullScreen)
                q.webkitRequestFullScreen();

            if ( window.screen.orientation ) {
                window.screen.orientation.lock("landscape-primary");
            }
            document.removeEventListener('click', doOnce);
        };
        document.addEventListener('click', doOnce);



        return () => window.screen.orientation.unlock();

    }, [container]);
}
